import { canonize } from './validatePhone';

export default canonize;
